import {
	IScheduleProgramFromBe,
	gbScheduleProgramFromBE,
	scheduleProgramFromBE,
} from '@common/api/schedulePrograms';
import backend from '@common/backend';

const BASE = '/scheduleLessons';

export interface IScheduleLessonsQuery {
	schedule_id?: number;
	period_start: string;
	period_end: string;
}

export interface IScheduleLessonFromBE {
	id: number;
	schedule_program_id: number;
	scheduleProgram: IScheduleProgramFromBe | null;
	schedule_program: IScheduleProgramFromBe | null;
	lesson: any; // @TODO: TS
	teacher_id: number;
	start: string;
	duration: number;
	deadline: number;
}

export const scheduleLessonFromBE = ({
	scheduleProgram,
	schedule_program,
	...scheduleLesson
}: IScheduleLessonFromBE) => ({
	...scheduleLesson,
	// eslint-disable-next-line no-nested-ternary
	scheduleProgram: scheduleProgram
		? scheduleProgramFromBE(scheduleProgram)
		: schedule_program
			? gbScheduleProgramFromBE(schedule_program)
			: null,
	schedule_program_id: scheduleProgram?.id || schedule_program?.id,
});

const scheduleLessonToBE = ({ scheduleProgram, lesson, ...scheduleLesson }: any) => ({
	schedule_program_id: scheduleProgram ? scheduleProgram.id : undefined,
	lesson_id: lesson ? lesson.id : undefined,
	...scheduleLesson,
});

export const getScheduleLesson = async (lessonId: number) => backend.get(`${BASE}/${lessonId}`);

export const getScheduleLessons = async (query?: IScheduleLessonsQuery) =>
	backend
		.get(`${BASE}/`, {
			params: {
				...query,
			},
		})
		.then((scheduleLessons: IScheduleLessonFromBE[]) => scheduleLessons.map(scheduleLessonFromBE));

export const createScheduleLesson = async (data: any) =>
	backend.post(`${BASE}/`, scheduleLessonToBE(data)).then(scheduleLessonFromBE);

export const createScheduleLessons = async (data: any) =>
	backend.post(`${BASE}/bulk/`, data).then(scheduleLessonFromBE);

export const saveScheduleLesson = async (id: number, data: any) =>
	backend.put(`${BASE}/${id}`, scheduleLessonToBE(data)).then(scheduleLessonFromBE);

export const saveScheduleLessons = async (data: any) =>
	backend.put(`${BASE}/bulk/`, data).then(scheduleLessonFromBE);

export const deleteScheduleLesson = async (id: number) => backend.delete(`${BASE}/${id}`);

export const deleteScheduleLessons = async (data: any[]) => backend.delete(`${BASE}/bulk`, data);

export interface UnlockScheduleLessonGradebooks {
	schedule_lesson_id: number;
	general_gradebook_id: number;
}

export const unlockScheduleLesson = async (data: UnlockScheduleLessonGradebooks) =>
	backend.post(`cheats/unlockScheduleLessonGradebooks`, data);
